import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1MystoreRequest } from '#shared/api/requests';
import {
    MyStoreApiCheckStoreINNMethod,
    type MyStoreApiCheckStoreINNResponseSuccess,
    type MyStoreApiCheckStoreINNSearchParams,
    MyStoreApiCheckStoreINNUrl,
    MyStoreApiCreateExternalStoreMethod,
    type MyStoreApiCreateExternalStoreRequest,
    type MyStoreApiCreateExternalStoreResponseSuccess,
    MyStoreApiCreateExternalStoreUrl,
    MyStoreApiCreateLiteStoreMethod,
    type MyStoreApiCreateLiteStoreRequest,
    type MyStoreApiCreateLiteStoreResponseSuccess,
    MyStoreApiCreateLiteStoreUrl,
    MyStoreApiCreateStoreMethod,
    type MyStoreApiCreateStoreRequest,
    type MyStoreApiCreateStoreResponseSuccess,
    MyStoreApiCreateStoreUrl,
    MyStoreApiGetUserInfoMethod,
    type MyStoreApiGetUserInfoRequest,
    type MyStoreApiGetUserInfoResponseSuccess,
    MyStoreApiGetUserInfoUrl,
} from '#shared/api/schema';

const storeApi = createApi({
    name: 'entities/store/api/api',
    baseQuery: createBaseQuery(apiV1MystoreRequest),
    endpoints: (builder) => {
        return {
            getUserInfo: builder.query<MyStoreApiGetUserInfoResponseSuccess, MyStoreApiGetUserInfoRequest>({
                query: () => {
                    return {
                        url: MyStoreApiGetUserInfoUrl,
                        method: MyStoreApiGetUserInfoMethod,
                    };
                },
                keepUnusedDataFor: 0,
            }),
            checkInn: builder.query<MyStoreApiCheckStoreINNResponseSuccess, MyStoreApiCheckStoreINNSearchParams>({
                query: (params) => {
                    return {
                        url: MyStoreApiCheckStoreINNUrl,
                        params,
                        method: MyStoreApiCheckStoreINNMethod,
                    };
                },
            }),
            createUserStore: builder.mutation<MyStoreApiCreateStoreResponseSuccess, MyStoreApiCreateStoreRequest>({
                query: (payload) => {
                    return {
                        url: MyStoreApiCreateStoreUrl,
                        method: MyStoreApiCreateStoreMethod,
                        body: payload,
                    };
                },
            }),
            createExternalStore: builder.mutation<
                MyStoreApiCreateExternalStoreResponseSuccess,
                MyStoreApiCreateExternalStoreRequest
            >({
                query: (payload) => {
                    return {
                        url: MyStoreApiCreateExternalStoreUrl,
                        method: MyStoreApiCreateExternalStoreMethod,
                        body: payload,
                    };
                },
            }),
            createLiteStore: builder.mutation<
                MyStoreApiCreateLiteStoreResponseSuccess,
                MyStoreApiCreateLiteStoreRequest
            >({
                query: (payload) => {
                    return {
                        url: MyStoreApiCreateLiteStoreUrl,
                        method: MyStoreApiCreateLiteStoreMethod,
                        body: payload,
                    };
                },
            }),
        };
    },
});

export const getStoreUserInfo = storeApi.endpoints.getUserInfo.query;
export const checkStoreInn = storeApi.endpoints.checkInn.query;
export const createUserStore = storeApi.endpoints.createUserStore.mutate;
export const createExternalStore = storeApi.endpoints.createExternalStore.mutate;
export const createLiteStore = storeApi.endpoints.createLiteStore.mutate;
